import type { TranslatedValue } from "@swo/storefront";
import React from "react";

export type PDPButtonWithAction =
  | { tag: "disabled"; label: TranslatedValue; icon: React.FC }
  | { tag: "action"; f: () => Promise<void>; label: TranslatedValue; icon: React.FC }
  | { tag: "internal-link"; href: string; label: TranslatedValue; icon: React.FC; onClick?: () => void };

export function pdpDisabledActionOf(label: TranslatedValue, icon: React.FC): PDPButtonWithAction {
  return { tag: "disabled", label, icon };
}

export type PdpAvailabilityState = {
  action: PDPButtonWithAction;
  extension:
    | {
        tag: "text";
        text: TranslatedValue;
      }
    | {
        tag: "component";
        Component: React.ReactNode;
        text: TranslatedValue;
      }
    | null;
};
